/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import "./ViewSkills.css";

import React, {useEffect, useState} from "react";
import {Badge, Button, Col, Dropdown, Form, Modal, Row, Spinner, Table} from "react-bootstrap";
import {API_ACTION, API_SKILL, API_SKILL_CATEGORIES, API_SKILL_QUESTIONS} from "../../const/Api";
import {GetRequest, PostRequest} from "../../lib/AxiosHelper";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {ALERT_VARIANT, QUESTION_TYPE, RESPONSE_STATUS} from "../../const/dataEnum";
import {setAlert} from "../../stores/actions/alertModalStateAction";
import DepartmentDropdown from "../../components/CommonDropdown/DepartmentDropdown";
import PracticeDropdown from "../../components/CommonDropdown/PracticeDropdown";

export default function ViewSkills() {
  const dispatch = useDispatch();

  const defaultSkill = {
    id: 0,
    name: "",
    description: "",
    skillCategoryID: 1,
    forSelf: 0,
    forPeer: 0,
    forManager: 0,
    weight: 0,
    skillType: QUESTION_TYPE.SCORE_5,
  };

  const userDepartmentId = useSelector(s => s.appState.user.departmentID, shallowEqual);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(userDepartmentId);
  const [selectedPractice, setSelectedPractice] = useState(null);

  const [skillCategoryList, setSkillCategoryList] = useState([]);
  const [skills, setSkills] = useState([]);
  const [responseStatus, setResponseStatus] = useState(RESPONSE_STATUS.IDLE);
  const [showEdit, setShowEdit] = useState(false);
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [action, setAction] = useState("Add");

  const [loadingModify, setLoadingModify] = useState(false);
  const [skillId, setSkillId] = useState(defaultSkill.id);
  const [skillName, setSkillName] = useState(defaultSkill.name);
  const [description, setDescription] = useState(defaultSkill.description);
  const [skillCategoryID, setSkillCategoryID] = useState(defaultSkill.skillCategoryID);
  const [isSelf, setIsSelf] = useState(defaultSkill.forSelf ? 1 : 0);
  const [isPeer, setIsPeer] = useState(defaultSkill.forPeer ? 1 : 0);
  const [isManager, setIsManager] = useState(defaultSkill.forManager ? 1 : 0);
  const [weight, setWeight] = useState(defaultSkill.weight);
  const [weightString, setWeightString] = useState(""); // for weight value before parseFloat()-ed
  const [skillType, setSkillType] = useState(defaultSkill.skillType);

  const [isUpdated, setIsUpdated] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  useEffect(() => {
    fetchSkillCategories();
    return () => {
    };
  }, []);
  useEffect(() => {
    if (selectedPractice?.id && selectedPeriod?.id) getSkills();
  }, [selectedPractice, selectedPeriod, skillCategoryID]);

  function callError(result) {
    if (result.responseCode !== 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
      return true;
    }
    return false;
  }

  const fetchSkillCategories = () => {
    GetRequest(dispatch, API_SKILL_CATEGORIES)
      .then((response) => {
        const {data, message, responseCode} = response.data;
        if (!callError(response.data)) {
          setSkillCategoryList(data);
        }
      })
      .catch((error) => {
        // dispatch(setAlert({ show: true, variant: ALERT_VARIANT.ERROR, message: error.data }));
      })
      .finally(() => {
      });
  };

  const getSkills = () => {
    if (selectedPractice.id !== null && selectedPeriod.id !== null) {
      setResponseStatus(RESPONSE_STATUS.PENDING);
      GetRequest(dispatch, `${API_SKILL_QUESTIONS}/${selectedPractice.id}/${selectedPeriod.id}`)
        .then((response) => {
          const {data, message, responseCode} = response.data;
          if (!callError(response.data)) {
            setSkills(data);
          } else {
            setSkills([]);
          }
          setResponseStatus(RESPONSE_STATUS.SUCCESS);
        })
        .catch((error) => {
          setSkills([]);
          setResponseStatus(RESPONSE_STATUS.ERROR);
          // dispatch(setAlert({ show: true, variant: ALERT_VARIANT.ERROR, message: error.data }));
        })
        .finally(() => {
        });
    }
  };

  function validateForm() {
    return skillName.length > 0 && parseFloat(weightString) > 0;
  }

  function viewQuestion(question) {
    openFormQuestion(question);
    setAction("View");
  }

  function editQuestion(question) {
    openFormQuestion(question);
    setAction("Edit");
  }

  function addQuestion() {
    openFormQuestion(defaultSkill);
    setWeightString("");
    setAction("Add");
  }

  function openFormQuestion(question) {
    setSkillName(question.name);
    setDescription(question.description);
    setSkillCategoryID(question.skillCategoryID);
    setIsSelf(question.forSelf ? 1 : 0);
    setIsPeer(question.forPeer ? 1 : 0);
    setIsManager(question.forManager ? 1 : 0);
    setWeight(question.weight);
    setSkillType(question.skillType);
    setShowEdit(true);
    setWeightString(question.weight.toFixed(1));
  }

  async function AddOrUpdateQuestion(e) {
    e.preventDefault();
    setLoadingModify(true);
    let param = {
      skillType: skillType,
      skillCategoryID: skillCategoryID,
      name: skillName,
      description: description,
      weight: parseFloat(weightString),
      forManager: isManager ? 1 : 0,
      forPeer: isPeer ? 1 : 0,
      forSelf: isSelf ? 1 : 0,
      departmentID: selectedDepartment.id,
      practiceID: selectedPractice.id,
      reviewPeriodID: selectedPeriod.id,
    };
    if (action === "Add") param = {...param, id: 0};
    else if (action === "Edit")
      param = {
        ...param,
        updated: isUpdated,
        deleted: isDeleted,
        id: 0,
        skillID: skillId,
      };

    PostRequest(dispatch, action === "Edit" ? API_SKILL + API_ACTION.MODIFY : API_SKILL + API_ACTION.CREATE, param)
      .then((response) => {
        const {data, message, responseCode} = response.data;
        if (!callError(response.data)) {
          dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: message}));
          getSkills();
          setShowEdit(false);
        }
      })
      .finally(() => {
        setLoadingModify(false);
      });
  }

  function deleteQuestion() {
    setLoadingModify(true);
    let param = {
      ...defaultSkill,
      departmentID: selectedDepartment.id,
      practiceID: selectedPractice.id,
      reviewPeriodID: selectedPeriod.id,
      updated: isUpdated,
      deleted: isDeleted,
      skillID: skillId,
    };

    PostRequest(dispatch, API_SKILL + API_ACTION.MODIFY, param)
      .then((response) => {
        const {data, message, responseCode} = response.data;
        if (!callError(response.data)) {
          dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: "Data successfully deleted"}));
          getSkills();
          setShowDeletePrompt(false);
        }
      })
      .finally(() => {
        setLoadingModify(false);
      });
  }

  const selection = (
    <div className="row mb-4">
      <div className="col-md-11 col-lg-11 col-sm-15">
        <div className="row g-3">
          {/* <div className="col-2">
            <label className="label">Period</label>
            <PeriodDropdown
              callbackChangePeriod={(value) => {
                setSelectedPeriod(value);
              }}
            />
          </div> */}
          <div className="col-3">
            <label className="label">Department</label>
            <DepartmentDropdown
              callbackChangeDepartment={(value) => {
                setSelectedDepartment(value);
              }}
              departmentValue={selectedDepartment}
            />
          </div>
          <div className="col-3">
            <label className="label">Practice</label>
            <PracticeDropdown
              callbackChangePractice={(value) => {
                setSelectedPractice(value);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const body = (
    <div className="container py-4">
      <Button
        disabled={!selectedPeriod?.isActive}
        onClick={() => {
          addQuestion();
        }}
      >
        Add Question
      </Button>

      <Table hover responsive>
        <thead>
        <tr>
          <th>#</th>
          <th>Skill</th>
          <th>Description</th>
          <th>Weight</th>
          <th>Category</th>
          <th>Type</th>
          <th>For Self</th>
          <th>For Peer</th>
          <th>For Manager</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        {responseStatus === RESPONSE_STATUS.PENDING ? (
          <tr>
            <td className="text-center" colSpan="10 ">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </td>
          </tr>
        ) : skills.length === 0 ? (
          <tr>
            <td className="text-center" colSpan="10">
              No Data Available
            </td>
          </tr>
        ) : (
          skills.map((question, index) => {
            return (
              <tr key={question.id}>
                <td>{index + 1}</td>
                <td>{question.name}</td>
                <td>{question.description ? question.description.substring(0, 97) + "..." : ""}</td>
                <td>{question.weight.toFixed(1)}</td>
                <td>{skillCategoryList.find((obj) => obj.id === question.skillCategoryID).category}</td>
                <td>
                  <Badge bg="primary" className="mx-0">
                    {question.skillType}
                  </Badge>
                </td>
                <td>
                  <Form.Check disabled defaultChecked={question.forSelf === 1} aria-label="option 1"/>
                </td>
                <td>
                  <Form.Check disabled defaultChecked={question.forPeer === 1} aria-label="option 1"/>
                </td>
                <td>
                  <Form.Check disabled defaultChecked={question.forManager === 1} aria-label="option 1"/>
                </td>
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic"></Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          viewQuestion(question);
                        }}
                      >
                        View Detail
                      </Dropdown.Item>
                      <Dropdown.Item
                        disabled={!selectedPeriod?.isActive}
                        onClick={() => {
                          editQuestion(question);
                          setSkillId(question.id);
                          setIsUpdated(true);
                          setIsDeleted(false);
                        }}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Divider/>
                      <Dropdown.Item
                        disabled={!selectedPeriod?.isActive}
                        onClick={() => {
                          setShowDeletePrompt(true);
                          setSkillId(question.id);
                          setIsUpdated(false);
                          setIsDeleted(true);
                        }}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })
        )}
        </tbody>
      </Table>

      <Modal show={showDeletePrompt} centered size="sm" aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header>
          <Modal.Title>Delete Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure to delete this item for this period?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => deleteQuestion()} disabled={loadingModify}>
            {loadingModify ? (
              <div>
                <span
                  style={{marginLeft: "0px"}}
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              "Delete"
            )}
          </Button>
          <Button variant="secondary" onClick={() => setShowDeletePrompt(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEdit} centered size="lg" aria-labelledby="contained-modal-title-vcenter">
        <Form onSubmit={AddOrUpdateQuestion}>
          <Modal.Header>
            <Modal.Title>{action} Question</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row g-3>
              <Col>
                <Form.Group size="lg" controlId="username" className="mb-2">
                  <Form.Label>Skill Type</Form.Label>
                  <Form.Control
                    as="select"
                    value={skillType ? skillType : undefined}
                    disabled={action === "View"}
                    onChange={(e) => setSkillType(e.target.value)}
                  >
                    <option value={QUESTION_TYPE.SCORE_20}>Score 1-20</option>
                    <option value={QUESTION_TYPE.SCORE_10}>Score 1-10</option>
                    <option value={QUESTION_TYPE.SCORE_5}>Score 1-5</option>
                    <option value={QUESTION_TYPE.ESSAY}>Essay</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group size="lg" controlId="username" className="mb-2">
                  <Form.Label>Skill Category</Form.Label>
                  <Form.Control
                    as="select"
                    value={skillCategoryID ? skillCategoryID : undefined}
                    disabled={action === "View"}
                    onChange={(e) => setSkillCategoryID(parseInt(e.target.value))}
                  >
                    {skillCategoryList.map((skillCategory) => (
                      <option key={skillCategory.id} value={skillCategory.id}>
                        {skillCategory.category}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row g-3>
              <Col>
                <Form.Group size="lg" controlId="username" className="mb-2">
                  <Form.Label>Question Title</Form.Label>
                  <Form.Control
                    autoFocus
                    placeholder="Question"
                    type="text"
                    value={skillName}
                    disabled={action === "View"}
                    onChange={(e) => setSkillName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col xs lg={3}>
                <Form.Group size="lg" controlId="username" className="mb-2">
                  <Form.Label>Weight</Form.Label>
                  <Form.Control
                    autoFocus
                    placeholder="1"
                    type="text"
                    value={weightString}
                    disabled={action === "View"}
                    onChange={(e) => setWeightString(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="exampleForm.ControlTextarea1" className="mb-3">
              <Form.Label>Question Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={description}
                disabled={action === "View"}
                onChange={(e) => setDescription(e.target.value)}
              />
              <div className="textCount">{description.length}/1500</div>
            </Form.Group>
            <div className="mb-3">
              <Form.Check
                inline
                checked={isSelf === 1}
                disabled={action === "View"}
                onChange={(e) => setIsSelf(e.target.checked ? 1 : 0)}
                label="For Self"
                type="checkbox"
              />
              <Form.Check
                inline
                checked={isPeer === 1}
                disabled={action === "View"}
                onChange={(e) => setIsPeer(e.target.checked ? 1 : 0)}
                label="For Peer"
                type="checkbox"
              />
              <Form.Check
                inline
                checked={isManager === 1}
                disabled={action === "View"}
                onChange={(e) => setIsManager(e.target.checked ? 1 : 0)}
                label="For Manager"
                type="checkbox"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {action !== "View" ? (
              <Button size="md" type="submit" style={{width: "150px"}} disabled={!validateForm() || loadingModify}>
                {loadingModify ? (
                  <div>
                    <span
                      style={{marginLeft: "0px"}}
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  "Save Changes"
                )}
              </Button>
            ) : (
              ""
            )}
            <Button variant="secondary" onClick={() => setShowEdit(false)} disabled={loadingModify}>
              {action === "View" ? "Close" : "Cancel"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
  return (
    <div className="container">
      {selection}
      {body}
    </div>
  );
}
